import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';

export interface IOrganizationReference extends IEntity {
  attributes: {
    id: EntityStringId;
    companyName: string;
  };
}

export type OrganizationReference = Entity<IOrganizationReference>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationReference: IEntityType<IOrganizationReference> = vmClient.defineClass({
  typeName: 'OrganizationReference',
  version: 2,
  persisted: true,
  attributes: {
    companyName: {
      type: 'string',
      notNull: true,
    },
  },
});
